// -------------------------- URL --------------------------
export const API_URL =
  process.env.BUN_PUBLIC_API_URL || "http://localhost:3000";

// -------------------------- POSTHOG --------------------------
// Token público del proyecto (`phc_...`) y host de su región, tal como los da
// PostHog. Son build args, como la llave de Culqi: cambiarlos exige reconstruir
// el frontend. Sin token la analítica queda apagada.
export const POSTHOG_TOKEN = process.env.BUN_PUBLIC_POSTHOG_TOKEN || "";
export const POSTHOG_HOST =
  process.env.BUN_PUBLIC_POSTHOG_HOST || "https://us.i.posthog.com";

// -------------------------- META (ADS) --------------------------
// ID del píxel. Build arg como las otras llaves públicas: cambiarlo exige
// reconstruir el frontend. Sin él, el píxel no se inicializa y no se manda nada.
// El token de la Conversions API NO vive acá: es de servidor.
export const META_PIXEL_ID = process.env.BUN_PUBLIC_META_PIXEL_ID || "";

// -------------------------- CAMPAÑAS --------------------------
// Fecha de campaña: hasta aquí el plan gratuito recibe el resumen a diario;
// después vuelve a semanal (los canales se quedan). La reversión es manual, en
// el seed — nada la apaga sola.
export const FREE_DAILY_ALERTS_UNTIL = "31 de octubre";

// Inteligencia de mercado (Empresas) está abierta a todos hasta esta fecha; después
// es del plan de pago. Igual que las de arriba, el cierre es manual: nada la apaga
// sola, solo deja de anunciarse el modal cuando la fecha pasa.
export const MARKET_INTELLIGENCE_FREE_UNTIL = "31 de octubre";
export const MARKET_INTELLIGENCE_FREE_ENDS_AT = new Date(
  "2026-10-31T23:59:59-05:00",
);


// -------------------------- VENTAS --------------------------
// Destinatario del "Hablar con ventas" del chat con IA (plan a medida, sin tabla
// de precios que lo cubra).
export const SALES_EMAIL = "sebastian@licitigo.com";

// Canales de la card "Reúnete con nosotros" del Descubrimiento: la agenda del
// equipo y el WhatsApp para quien prefiere escribir en vez de agendar.
export const SALES_CALENDLY_URL = "https://calendly.com/sebastian-licitigo";
export const SALES_WHATSAPP = "51998139015";
// Foto del asesor que atiende esas dos vías: le pone cara a la card.
export const SALES_ADVISOR_PHOTO_URL =
  "https://pub-0dca39eb741341ea977662839c163ab9.r2.dev/foto_de_debas.png";
export const SALES_ADVISOR_NAME = "Sebastián";

// -------------------------- CULQI --------------------------
// Llave pública del checkout (`pk_test_` en integración, `pk_live_` en producción).
// Es pública por diseño: solo sirve para tokenizar la tarjeta en el navegador.
export const CULQI_PUBLIC_KEY = process.env.BUN_PUBLIC_CULQI_PUBLIC_KEY || "";

// Entorno de pruebas de Culqi: ningún cobro es real. Se deriva del prefijo de la
// llave para que el aviso desaparezca solo al pasar a producción.
export const CULQI_SANDBOX = CULQI_PUBLIC_KEY.startsWith("pk_test_");
